<template>
	<el-dialog
		title
		:visible.sync="showReadDialog"
		:close-on-click-modal="false"
		:modal="false"
		:width="isPhone === 'true' ? '80%' : '697px'"
		class="read_box"
		:before-close="closed"
		append-to-body
		:showClose="isPhone === 'true' ? false : true"
	>
		<div class="content">
			<div class="left" v-if="isPhone !== 'true'">
				<svg id="logo" viewBox="0 0 1024 1024">
					<path
						d="M960 1024H64a64 64 0 0 1-64-64V64A64 64 0 0 1 64 0h896a64 64 0 0 1 64 64v896a64 64 0 0 1-64 64"
						fill="#14A8F0"
					/>
					<path
						d="M907.273 370.476l-71.098 71.089c33.987 45.02 30.482 109.524-10.504 150.528-44.845 44.844-117.813 44.844-162.649 0l-58.685-58.686-70.71 70.709 58.678 58.694h0.008c40.607 40.599 94.597 62.976 152.03 62.976 57.431 0 111.42-22.377 152.028-62.976a213.619 213.619 0 0 0 62.967-152.028c0-52.065-18.38-101.306-52.065-140.306"
						fill="#FFFFFF"
					/>
					<path
						d="M813.56 418.94l71.088-71.089c-39-33.686-88.24-52.083-140.306-52.083a213.557 213.557 0 0 0-152.011 62.985L348.248 602.827A865.668 865.668 0 0 1 207.59 714.143a213.866 213.866 0 0 0 22.88 6.444h0.01a215.927 215.927 0 0 0 47.174 5.2 213.61 213.61 0 0 0 152.029-62.977l197.985-198.002 81.32 81.328 70.709-70.709-73.216-73.225a115.765 115.765 0 0 1 37.87-6.364c24.4 0 48.799 7.706 69.208 23.102M190.455 687.113a830.676 830.676 0 0 0 84.471-61.423 114.564 114.564 0 0 1-78.583-33.606c-44.844-44.835-44.844-117.787 0-162.622a114.582 114.582 0 0 1 81.302-33.633c29.458 0 58.907 11.211 81.329 33.633a114.635 114.635 0 0 1 33.598 83.774l84.1-84.1a214.775 214.775 0 0 0-46.98-70.392c-40.616-40.607-94.606-62.976-152.038-62.976-57.423 0-111.413 22.37-152.029 62.976a213.601 213.601 0 0 0-62.967 152.029 213.601 213.601 0 0 0 62.967 152.029 215.95 215.95 0 0 0 46.963 35.645l17.867-11.334z"
						fill="#FFFFFF"
					/>
				</svg>
				<p>数科OFD</p>
			</div>
			<div class="right" :class="{ 'active': isPhone === 'true' }">
				<h2>关于网页轻阅读</h2>
				<h6>{{version}}</h6>
				<p>版权所有：© 2006一2020 北京数科网维技术有限责任公司 保留所有权利</p>
				<div class="tips">
					<p>无需下载文档 · 无需安装插件</p>
					<p>快捷轻松阅读 · 高效安全应用</p>
				</div>
				<p>
					网页轻阅读系统可将常用办公文档一键式发布成HTML网页，
					并根据用户阅读需求进行实时推送，使用户无需安装任何插件，即可通过浏览器原版原式阅读文档内容。系统支持PC、平板电脑、手机等各类终端设备，Windows、Linux、iOS、
					Android等各类操作系统，实现全面跨平台兼容和一致性用户体验。
				</p>
			</div>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button type="primary" @click="closed" size="mini" class="mini_btn">关闭</el-button>
		</div>
	</el-dialog>
</template>

<script>
export default {
	props: {
		showReadDialog: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			isPhone: null,
			version: ""

		};
	},
	created() {
		this.isPhone = localStorage.getItem("isPhone");
		
	},
	watch: {

	},
	mounted(){
		window.addEventListener('message', (e) => {
			if(e.data.version){
				this.version=e.data.version
			}
		})
	},
	computed: {},
	methods: {
		closed() {
			this.$emit("closed", false);
		}
	}
};
</script>
<style lang="scss">
.read_box {
	.el-dialog__header {
		padding: 15px 0;
	}
	.el-dialog__body {
		padding: 0 40px 15px !important;
	}
	.el-dialog__headerbtn {
		top: 30px;
		right: 40px;
	}
	.el-dialog__headerbtn .el-dialog__close {
		font-size: 38px;
	}
}
</style>
<style lang="scss" scoped>
.read_box {
	.content {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		line-height: 1.5;
		.left {
			width: 94px;
			p {
				font-size: 22px;
				color: #333;
				margin-top: 20px;
			}
		}
		.right {
			flex: 1;
			padding-left: 50px;
			color: #333;
			&.active {
				padding-left: 0;
			}
			h2 {
				font-size: 24px;
				margin: 5px 0;
			}
			h6 {
				color: rgb(153, 153, 153);
				margin-bottom: 30px;
			}
			p {
				font-size: 12px;
				margin: 5px 0;
			}
			.tips {
				margin: 30px 0;
				p {
					color: rgb(102, 102, 102);
				}
			}
		}
	}
	.dialog-footer {
		padding: 0 40px 20px;
		.mini {
			width: 72px !important;
			height: 30px !important;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/comm/components/document-conversion/aboutRead/index.vue